import { UserSelector } from "@/components/admin/user-selector";
import { ButtonLoading } from "@/components/button-loading";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useToast, useToastError } from "@/components/ui/use-toast";
import { useAdminTeamsEmitter } from "@/hooks/useAdminTeamsEvents";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminTeamDTO, AdminUserDTO } from "@shaarp/common";
import { useState } from "react";

export const DialogAdminTeamAdvisor = ({
  team,
  open,
  onClose,
}: {
  team: AdminTeamDTO;
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const api = useApi();
  const toastError = useToastError();
  const { toast } = useToast();
  const { refreshTeams } = useAdminTeamsEmitter();

  const [isLoading, setIsLoading] = useState(false);
  const [advisorSelected, setAdvisorSelected] = useState<AdminUserDTO | null>(
    null
  );

  const save = async () => {
    setIsLoading(true);
    try {
      await api.post(`/admin/team/${team.id}/advisor`, {
        userId: advisorSelected?.id || null,
      });
      refreshTeams();
      toast({
        variant: "default",
        title: t(
          "admin.dataTableAdminTeams.dialogs.advisor.toast.success.title"
        ),
        description: t(
          "admin.dataTableAdminTeams.dialogs.advisor.toast.success.description"
        ),
      });

      onClose();
    } catch (error) {
      toastError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("admin.dataTableAdminTeams.dialogs.advisor.title")}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <UserSelector
              onSelect={(user) => setAdvisorSelected(user)}
              defaultSelectedUserId={team.advisorUserId}
              filter={(user) => !!user.advisorLicence}
            />
          </div>
        </div>
        <DialogFooter>
          <ButtonLoading onClick={save} isLoading={isLoading}>
            {t("admin.dataTableAdminTeams.dialogs.advisor.save")}
          </ButtonLoading>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
